import { format } from 'date-fns';
import { TicketSearchRequest } from '../../types/interfaces/ticket';

export type NormalizedTicketSearchRequest = Partial<
  Omit<TicketSearchRequest, 'date' | 'endDate'>
> & {
  date?: string;
  endDate?: string;
};

export function normalizeTicketSearchRequest(
  request: TicketSearchRequest,
): NormalizedTicketSearchRequest {
  const normalized: NormalizedTicketSearchRequest = {};
  const filter = request.filter?.trim();

  if (filter) {
    normalized.filter = filter;
  }

  if (request.queueIds?.length) {
    normalized.queueIds = request.queueIds;
  }

  if (request.statusIds?.length) {
    normalized.statusIds = request.statusIds;
  }

  if (request.date instanceof Date && !Number.isNaN(request.date.getTime())) {
    normalized.date = format(request.date, 'yyyy-MM-dd');
  }

  if (
    request.endDate instanceof Date &&
    !Number.isNaN(request.endDate.getTime())
  ) {
    normalized.endDate = format(request.endDate, 'yyyy-MM-dd');
  }

  if (request.includeMessages) {
    normalized.includeMessages = true;
  }

  if (request.includeTickets) {
    normalized.includeTickets = true;
  }

  return normalized;
}
